import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B42318",
      d: "m7.582 9.436 3.129-3.129.825.825-4.538 4.537-4.537-4.537.825-.825 3.129 3.129v-7.1h1.167z"
    }, null, -1)
  ]))]))
}
export default { render: render }